var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M10 8.64L15.27 12L10 15.36V8.64ZM8 5V19L19 12L8 5Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }